import AppConfig from "util/AppConfig";
const useWelcomeCustomization = () => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return {
    isNewsSectionEnabledForBrand: ((_d = (_c = (_b = (_a = AppConfig) == null ? void 0 : _a.branding()) == null ? void 0 : _b.welcome) == null ? void 0 : _c.news) == null ? void 0 : _d.enabled) !== false,
    isReleaseSectionEnabledForBrand: ((_h = (_g = (_f = (_e = AppConfig) == null ? void 0 : _e.branding()) == null ? void 0 : _f.welcome) == null ? void 0 : _g.releases) == null ? void 0 : _h.enabled) !== false
  };
};
export default useWelcomeCustomization;
